/**
 * Theme utility functions for managing dark/light mode
 */

/**
 * Apply theme to document
 * @param {string} theme - 'light', 'dark', or 'system'
 */
export const applyTheme = (theme) => {
  const root = document.documentElement;
  
  if (theme === 'system') {
    // Check system preference
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)')?.matches;
    if (systemPrefersDark) {
      root.classList?.add('dark');
    } else {
      root.classList?.remove('dark');
    }
  } else if (theme === 'dark') {
    root.classList?.add('dark');
  } else {
    root.classList?.remove('dark');
  }
  
  // Save to localStorage
  localStorage.setItem('theme', theme);
};

/**
 * Get saved theme from localStorage or default to 'system'
 * @returns {string} theme preference
 */
export const getSavedTheme = () => {
  return localStorage.getItem('theme') || 'system';
};

/**
 * Initialize theme on app load
 */
export const initializeTheme = () => {
  const savedTheme = getSavedTheme();
  applyTheme(savedTheme);
  
  // Listen for system theme changes if using 'system' preference
  if (savedTheme === 'system') {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      if (getSavedTheme() === 'system') {
        applyTheme('system');
      }
    };
    
    // Modern browsers
    if (mediaQuery?.addEventListener) {
      mediaQuery?.addEventListener('change', handleChange);
    } else {
      // Fallback for older browsers
      mediaQuery?.addListener(handleChange);
    }
  }
};